import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { MeinBereichPaper } from '../../../../components/ui-component/mein-bereich/MeinBereichComponents';
import { useNavigate } from 'react-router-dom';
import EmailIcon from '@mui/icons-material/Email';
import { useFetchnachrichtenStartSeite } from '../../../../hooks/FetchNachrichten';
import LoadingBackdrop from '../../../../components/ui-component/loading/LoadingBackdrop';
import { get } from 'lodash';

import Schema from '../../../../lib/paths/portal45nachricht_FULL_Paths.json';
import { DisplayDateTime } from '../../../../utils/formats';
const P = Schema.attributes;

function Nachrichten() {
	const navigate = useNavigate();
	const { loading, error, data } = useFetchnachrichtenStartSeite();

	if (error) console.error('ERROR Fetching Nachrichten', error);
	if (loading) return <LoadingBackdrop />;
	return (
		<>
			<MeinBereichPaper title="Nachrichten" titleIcon={<EmailIcon />}>
				{data?.map((ele, i) => (
					<Box key={i} sx={{ bgcolor: '#3c3939', padding: '1rem', width: '100%', borderRadius: '16px' }}>
						<Stack spacing={1} alignItems={'stretch'}>
							<Stack direction={'row'} justifyContent={'flex-end'}>
								<Typography variant={'caption'}>
									Erstellt am: {DisplayDateTime(get(ele, 'attributes.createdAt'))}
								</Typography>
							</Stack>
							<Stack direction={'row'} justifyContent={'space-between'}>
								<Typography variant={'subtitle1'}>{get(ele, P.Allgemein_Betreff.path)}</Typography>
							</Stack>
							<Typography
								variant="body2"
								color="text.primary"
								component={'div'}
								sx={{
									height: '2.5rem',
									// lineHeight: '1.3rem',
									overflow: 'hidden',
									display: '-webkit-box',
									WebkitBoxOrient: 'vertical',
									WebkitLineClamp: 2,
								}}
							>
								<div
									id="no-margin"
									dangerouslySetInnerHTML={{
										__html: get(ele, P.Allgemein_Inhalt.path),
									}}
								></div>
							</Typography>
							<Stack direction={'row'} justifyContent={'flex-end'}>
								<Button
									variant={'text'}
									onClick={() => navigate(`/meine-nachrichten/nachricht-details/${get(ele, 'id')}`)}
								>
									Ansehen
								</Button>
							</Stack>
						</Stack>
					</Box>
				))}

				<Button variant={'outlined'} onClick={() => navigate('/meine-nachrichten')}>
					Alle anzeigen
				</Button>
			</MeinBereichPaper>
		</>
	);
}

export default Nachrichten;
